// extracted by mini-css-extract-plugin
module.exports = {"title":"ConsentItem_title__2Ilwo","titleWithdrawn":"ConsentItem_titleWithdrawn__2ayur","date":"ConsentItem_date__2-6st","container":"ConsentItem_container__1t_VM"};